var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnableImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2B8BC6",
    points: "212.855,85.535 148.803,149.576 111.471,112.214 99.021,124.65 148.927,174.602 161.377,162.159  161.234,162.021 225.295,97.976  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M149.255,2.415c-81.69,0-147.917,66.216-147.917,147.907c0,81.682,66.227,147.897,147.917,147.897 c81.747,0,147.966-66.216,147.966-147.897C297.223,68.631,231.002,2.415,149.255,2.415z M156.615,280.406v-29.579 c0-4.861-3.938-8.8-8.797-8.8s-8.799,3.938-8.799,8.8v29.358C74.835,275.172,23.58,223.484,19.264,159.12h28.043 c4.861,0,8.799-3.938,8.799-8.798c0-4.856-3.938-8.799-8.799-8.799H19.264c4.32-64.37,55.567-116.048,119.746-121.071v29.36 c0,4.856,3.937,8.798,8.798,8.798c4.86,0,8.797-3.942,8.797-8.798V20.231c65.553,3.663,118.297,55.951,122.687,121.283h-30.976 c-4.858,0-8.799,3.941-8.799,8.797s3.938,8.798,8.799,8.798h30.979C274.918,224.441,222.173,276.739,156.615,280.406z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M288.916,153.684c-1.891,0-3.789-0.656-5.334-1.994L149.65,35.48L16.499,151.621 c-3.381,2.952-8.535,2.604-11.49-0.784c-2.959-3.39-2.609-8.535,0.781-11.491L144.281,18.549 c3.064-2.673,7.623-2.677,10.689-0.014L294.26,139.387c3.396,2.948,3.76,8.092,0.811,11.489 C293.461,152.732,291.199,153.684,288.916,153.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M254.727,148.401l-99.521-88.567c-3.096-2.757-7.767-2.748-10.848,0.016l-99.033,88.688 c-1.727,1.544-2.708,3.751-2.708,6.067v113.229c0,4.497,3.645,8.146,8.144,8.146h81.543v-64.418h35.462l-0.004,64.418h81.553 c4.496,0,8.144-3.647,8.144-8.146v-113.35C257.455,152.16,256.461,149.946,254.727,148.401z M241.168,259.689h-57.115v-56.271 c0-4.498-3.648-8.146-8.143-8.146h-51.753c-4.5,0-8.144,3.647-8.144,8.146v56.271H58.902V158.243l90.906-81.41l91.36,81.306 V259.689z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M267.535,31.143h-27.709V49.36h27.709c4.232,0,7.807,3.579,7.807,7.809v47.975H23.215V57.168 c0-4.229,3.574-7.809,7.809-7.809h33.224v23.302c0,5.032,4.077,9.109,9.109,9.109c5.032,0,9.108-4.077,9.108-9.109V49.36h0.056 V31.143h-0.056V12.07c0-5.027-4.077-9.109-9.108-9.109c-5.033,0-9.109,4.082-9.109,9.109v19.072H31.024 c-14.315,0-26.026,11.711-26.026,26.026v211.854c0,14.312,11.711,26.024,26.026,26.024h236.511 c14.312,0,26.025-11.712,26.025-26.024V57.168C293.561,42.854,281.85,31.143,267.535,31.143z M267.535,276.828H31.024 c-4.234,0-7.809-3.573-7.809-7.807V123.361h252.126v145.661C275.342,273.255,271.77,276.828,267.535,276.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M200.885,72.662c0,5.032,4.075,9.109,9.107,9.109c5.033,0,9.111-4.077,9.111-9.109V12.07 c0-5.027-4.078-9.109-9.111-9.109c-5.032,0-9.107,4.082-9.107,9.109v19.072h-29.244V49.36h29.244V72.662L200.885,72.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8BC6",
    d: "M132.566,72.662c0,5.032,4.077,9.109,9.109,9.109c5.031,0,9.11-4.077,9.11-9.109V49.36h0.033V31.143 h-0.033V12.07c0-5.027-4.079-9.109-9.11-9.109c-5.032,0-9.109,4.082-9.109,9.109v19.072h-29.224V49.36h29.224V72.662z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.22,
    y: 189.876,
    fill: "#2B8BC6",
    width: 20.821,
    height: 20.819
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.734,
    y: 189.876,
    fill: "#2B8BC6",
    width: 20.821,
    height: 20.819
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.246,
    y: 189.876,
    fill: "#2B8BC6",
    width: 20.818,
    height: 20.819
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.758,
    y: 189.876,
    fill: "#2B8BC6",
    width: 20.826,
    height: 20.819
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.273,
    y: 189.876,
    fill: "#2B8BC6",
    width: 20.818,
    height: 20.819
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.734,
    y: 148.319,
    fill: "#2B8BC6",
    width: 20.821,
    height: 20.822
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.246,
    y: 148.319,
    fill: "#2B8BC6",
    width: 20.818,
    height: 20.822
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.758,
    y: 148.319,
    fill: "#2B8BC6",
    width: 20.826,
    height: 20.822
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.273,
    y: 148.319,
    fill: "#2B8BC6",
    width: 20.818,
    height: 20.822
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.22,
    y: 231.432,
    fill: "#2B8BC6",
    width: 20.821,
    height: 20.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.734,
    y: 231.432,
    fill: "#2B8BC6",
    width: 20.821,
    height: 20.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.246,
    y: 231.432,
    fill: "#2B8BC6",
    width: 20.818,
    height: 20.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.758,
    y: 231.432,
    fill: "#2B8BC6",
    width: 20.826,
    height: 20.82
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#68C7BD",
    stroke: "#68C7BD",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M150.35,6.245 c-78.731,0-142.784,64.05-142.784,142.778c0,78.732,64.053,142.786,142.784,142.786c78.729,0,142.783-64.054,142.783-142.786 C293.133,70.294,229.078,6.245,150.35,6.245z M150.35,283.491c-74.147,0-134.466-60.323-134.466-134.468 c0-74.141,60.319-134.46,134.466-134.46c74.144,0,134.466,60.319,134.466,134.46C284.816,223.168,224.493,283.491,150.35,283.491 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#68C7BD",
    stroke: "#68C7BD",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    points: "123.635,188.682 88.938,153.98  83.058,159.861 123.635,200.441 217.641,106.432 211.759,100.551  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAA742",
    d: "M106.968,20.121L101.708,4C70.733,14.099,43.388,32.822,22.63,58.153l13.112,10.749 C54.442,46.076,79.073,29.213,106.968,20.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA742",
    d: "M264.718,68.901l13.112-10.749C257.059,32.822,229.713,14.095,198.748,4l-5.262,16.121 C221.378,29.208,246.005,46.076,264.718,68.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA742",
    d: "M271.193,157.355c0-66.805-54.158-120.962-120.96-120.962c-66.803,0-120.966,54.159-120.966,120.962 c0,38.172,17.701,72.193,45.322,94.359l-14.044,26.553c-2.19,4.139-0.605,9.268,3.529,11.457c1.267,0.668,2.62,0.982,3.955,0.982 c3.042,0,5.979-1.643,7.502-4.514l13.094-24.75c18.046,10.705,39.101,16.867,61.609,16.867c22.507,0,43.562-6.162,61.607-16.873 l13.091,24.75c1.519,2.877,4.461,4.52,7.498,4.52c1.336,0,2.693-0.314,3.953-0.982c4.145-2.189,5.725-7.318,3.533-11.457 l-14.039-26.553C253.496,229.551,271.193,195.527,271.193,157.355z M46.22,157.355c0-57.349,46.661-104.008,104.013-104.008 c57.351,0,104.007,46.661,104.007,104.008c0,57.35-46.656,104.006-104.007,104.006C92.881,261.361,46.22,214.705,46.22,157.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA742",
    d: "M149.735,85.509c-0.004,0-0.014,0-0.022,0c-4.674,0-8.463,3.78-8.477,8.453l-0.172,59.007l-31.58,20.975 c-3.902,2.589-4.966,7.854-2.375,11.752c1.638,2.46,4.324,3.789,7.068,3.789c1.613,0,3.244-0.459,4.682-1.414l35.025-23.26 c0.587-0.39,1.087-0.856,1.54-1.356c1.581-1.533,2.575-3.672,2.579-6.047l0.185-63.396 C158.203,89.332,154.42,85.523,149.735,85.509z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28356B",
    d: "M267.686,35.172l-1.66-2.124c-25.563-32.835-73.303-39.05-106.424-13.844l-0.488,0.371 c7.111,4.968,14.68,8.772,18.688,8.587c24.851-13.415,56.671-7.363,74.527,15.576l1.659,2.124 c20.012,25.7,17.22,65.006-6.295,87.707l-17.305,17.154c-1.009,0.969-4.197,4.295-5.896,7.993 c-10.247,9.908-12.951,50.479-13.373,83.581c-0.011,1.043-0.479,25.635-21.604,32.907c-0.298,0.101-0.599,0.228-0.88,0.353 c-3.083,1.449-7.297,2.754-8.454,2.822c-2.752-2.623-3.807-17.404-3.131-43.895c0.131-4.161,0.828-41.108-13.793-56.186 c-3.975-4.102-8.885-6.361-14.237-6.808c-0.577-0.12-1.168-0.188-1.778-0.188c-0.01,0-0.021,0.004-0.029,0.004 c-0.01,0-0.02-0.004-0.029-0.004c-0.611,0-1.203,0.066-1.779,0.187c-5.346,0.444-10.257,2.704-14.238,6.807 c-14.621,15.076-13.921,52.021-13.796,56.146c0.678,26.531-0.374,41.312-2.909,43.795c-1.387,0.023-5.585-1.228-8.658-2.67 c-0.286-0.137-0.583-0.262-0.887-0.362c-21.131-7.272-21.601-31.864-21.611-32.978c-0.412-32.58-3.044-72.524-12.949-83.119 c-0.087-0.102-0.146-0.211-0.232-0.307c-7.519-7.97-8.803-9.761-13.075-15.687l-14.838-20.547 c-18.888-26.148-13.545-63.546,11.9-83.365l2.138-1.662c23.869-18.584,54.061-15.886,80.631,7.075 c0.665,0.598,16.536,14.679,37.042,15.29c4.992,0.286,8.792-3.626,8.938-8.423c0.146-4.796-3.625-8.798-8.426-8.941 c-14.02-0.419-25.836-10.757-26.062-10.955C115.41,3.1,76.019,0.128,45.576,23.833l-2.139,1.663 C10.701,50.993,3.827,99.101,28.124,132.741l14.824,20.522c4.532,6.297,6.225,8.648,14.534,17.459 c0.028,0.022,0.057,0.041,0.077,0.064c0.021,0.018,0.024,0.041,0.039,0.059c1.013,1.678,7.616,14.762,8.333,71.488 c0,1.537,0.374,37.622,32.882,49.143c2.695,1.239,9.632,4.129,15.687,4.129c0.69,0,1.368-0.037,2.022-0.117 c18.402-2.27,19.158-24.739,18.217-61.536c-0.334-10.873,1.401-35.827,8.905-43.56c1.445-1.488,2.569-1.703,3.568-1.709 c0.998,0.006,2.122,0.219,3.567,1.705c6.826,7.025,9.316,29.707,8.9,43.604c-0.938,36.754-0.177,59.226,18.223,61.493 c0.658,0.078,1.334,0.117,2.021,0.117c6.062,0,12.995-2.89,15.692-4.129c32.503-11.521,32.876-47.604,32.876-49.033 c0.723-56.832,7.325-69.92,8.334-71.599c0.575-0.585,0.979-1.276,1.358-1.978c0.842-0.819,1.582-1.762,2.043-2.93 c0.256-0.504,1.31-1.828,2.308-2.803l17.307-17.15C289.473,117.389,292.996,67.686,267.686,35.172z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M56.28,140.587c-4.187,0-7.787-3.159-8.246-7.416c-0.347-3.219-0.519-6.438-0.519-9.561 c0-27.039,12.049-52.372,33.057-69.489c3.553-2.9,8.783-2.361,11.678,1.191c2.9,3.552,2.363,8.783-1.19,11.678 c-17.121,13.952-26.942,34.589-26.942,56.62c0,2.534,0.145,5.16,0.427,7.791c0.486,4.559-2.812,8.649-7.371,9.14 C56.874,140.573,56.572,140.587,56.28,140.587z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M171.373,140.055h-53.14c-18.266,0-33.205,14.939-33.205,33.205v22.489 c5.16,3.739,10.696,6.976,16.602,9.552V173.26c0-9.152,7.448-16.603,16.603-16.603h53.14c9.154,0,16.604,7.448,16.604,16.603 v23.448c6.146-4.294,11.715-9.343,16.603-15.008v-8.44C204.578,154.994,189.641,140.055,171.373,140.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M277.796,242.493l-40.194-49.218c13.766-19.785,21.86-43.794,21.86-69.667 c0-67.446-54.87-122.32-122.321-122.32c-67.45,0-122.32,54.875-122.32,122.32c0,67.452,54.87,122.321,122.32,122.321 c16.691,0,32.597-3.367,47.106-9.443l40.38,49.443c6.967,8.522,17.715,13.012,28.739,11.987 c6.577-0.599,12.737-3.126,17.853-7.296l1.898-1.548c6.826-5.576,11.072-13.509,11.962-22.317 C285.967,257.938,283.383,249.322,277.796,242.493z M31.423,123.61c0-58.292,47.426-105.718,105.718-105.718 c58.292,0,105.718,47.426,105.718,105.718c0,58.297-47.426,105.718-105.718,105.718 C78.849,229.328,31.423,181.907,31.423,123.61z M268.005,265.029c-0.428,4.263-2.483,8.078-5.755,10.752l-1.898,1.553 c-2.443,1.996-5.399,3.205-8.562,3.496c-5.326,0.495-10.522-1.662-13.858-5.762l-38.004-46.527 c9.881-5.936,18.85-13.229,26.659-21.619l37.933,46.436C267.188,256.631,268.432,260.777,268.005,265.029z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M144.798,47.979c-21.581,0-39.078,17.501-39.078,39.083s17.497,39.08,39.078,39.08 c21.587,0,39.08-17.498,39.08-39.08S166.385,47.979,144.798,47.979z M144.798,109.537c-12.391,0-22.475-10.08-22.475-22.476 c0-12.391,10.084-22.48,22.475-22.48c12.394,0,22.478,10.089,22.478,22.48C167.275,99.458,157.189,109.537,144.798,109.537z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M16.521,235.021c0-8.782,7.147-15.932,15.93-15.932h74.654c8.782,0,15.93,7.146,15.93,15.932v50.309 h15.543v-50.309c0-17.311-14.165-31.475-31.473-31.475H32.451C15.143,203.548,1,217.712,1,235.021v50.309h15.521V235.021z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M258.898,3.065h-94.812c-21.428,0-38.858,17.43-38.858,38.858v48.161 c0,21.424,17.43,38.858,38.858,38.858h5.871l-23.99,22.261c-3.145,2.918-3.331,7.836-0.412,10.984 c1.536,1.646,3.613,2.483,5.698,2.483c1.896,0,3.791-0.688,5.286-2.076l52.845-49.198h-45.298 c-12.854,0-23.315-10.46-23.315-23.315v-48.16c0-12.859,10.459-23.314,23.315-23.314h94.812 c12.854,0,23.313,10.456,23.313,23.314v48.161c0,12.854-10.46,23.315-23.313,23.315h-25.621l-16.715,15.543h42.336 c21.43,0,38.856-17.434,38.856-38.858v-48.16C297.757,20.495,280.328,3.065,258.898,3.065z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M68.893,93.878c-25.518,0-46.2,20.687-46.2,46.201c0,25.521,20.682,46.204,46.2,46.204 c25.523,0,46.2-20.684,46.2-46.204C115.093,114.565,94.416,93.878,68.893,93.878z M68.893,170.739 c-16.905,0-30.657-13.757-30.657-30.66c0-16.905,13.751-30.657,30.657-30.657c16.906,0,30.657,13.752,30.657,30.657 C99.55,156.982,85.798,170.739,68.893,170.739z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M36.318,113.606c-4.95,0-8.97,4.016-8.97,8.966c0,4.958,4.02,8.974,8.97,8.974 c4.958,0,8.97-4.016,8.97-8.974C45.289,117.622,41.277,113.606,36.318,113.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M68.875,205.27V39.883h174.566c3.461,0,6.379,2.923,6.379,6.379v99.909l14.885,2.268V46.262 c0-11.694-9.568-21.262-21.264-21.262H24.5C12.806,25,3.238,34.568,3.238,46.262v152.628c0,11.691,9.568,21.26,21.262,21.26 h122.617l-12.354-14.883H68.875V205.27z M18.121,198.891V46.262c0-3.456,2.924-6.379,6.379-6.379h29.492v165.385H24.5 C21.045,205.27,18.121,202.346,18.121,198.891z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M274.707,161.425l-42.639-6.856v-41.783c0-11.138-9.062-20.199-20.199-20.199h-1.062 c-11.137,0-20.199,9.061-20.199,20.199l-0.008,75.301l-10.561-10.677c-3.812-3.857-8.911-5.984-14.359-5.984 c-5.365,0-10.406,2.072-14.197,5.827l-1.398,1.382c-7.92,7.833-7.986,20.648-0.153,28.567l51.397,51.566 c1.447,1.428,3.339,2.14,5.227,2.14c1.922,0,3.84-0.734,5.297-2.22c2.887-2.922,2.854-7.636-0.074-10.521l-51.267-51.433 c-2.024-2.051-2.01-5.493,0.038-7.521l1.403-1.387c0.985-0.976,2.312-1.521,3.729-1.521c1.439,0,2.781,0.557,3.778,1.562 l17.548,17.753c1.084,0.992,2.334,1.615,3.594,2.016c3.313,1.037,6.61,0.45,6.61,0.45c3.529-0.821,5.535-3.587,6.688-6.549 c0.938-2.403,1.316-4.933,1.461-6.677c0.107-1.321,0.089-2.188,0.089-2.188l0.009,0.009l0.021,0.028l0.012-79.927 c0-2.932,2.383-5.315,5.314-5.315h1.062c2.933,0,5.314,2.384,5.314,5.315v54.318l54.881,8.965 c0.102,0.023,9.844,2.139,9.97,16.522l-4.638,58.158c-0.326,4.096,2.729,7.685,6.828,8.011c0.199,0.014,0.398,0.021,0.6,0.021 c3.841,0,7.102-2.953,7.406-6.85l4.66-58.47c0.018-0.196,0.024-0.396,0.024-0.596 C296.917,171.508,282.574,162.994,274.707,161.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M228.979,65.041c0-3.525-2.855-6.379-6.377-6.379H94.568c-3.505,0-6.345,2.854-6.345,6.379 c0,3.522,2.84,6.379,6.345,6.379H222.6C226.121,71.419,228.979,68.562,228.979,65.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M189.678,87.569c-0.277-0.038-0.553-0.088-0.843-0.088H94.568c-3.505,0-6.345,2.857-6.345,6.379 c0,3.525,2.84,6.378,6.345,6.378h85.396C182.432,94.724,186.376,90.446,189.678,87.569z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M88.223,180.332c0,3.525,2.84,6.379,6.345,6.379h37.275c1.091-4.867,3.45-9.179,6.112-12.758H94.568 C91.063,173.953,88.223,176.811,88.223,180.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M177.211,116.31H94.568c-3.505,0-6.345,2.853-6.345,6.378c0,3.521,2.84,6.379,6.345,6.379h82.643V116.31z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M177.211,145.129H94.568c-3.505,0-6.345,2.857-6.345,6.378c0,3.525,2.84,6.379,6.345,6.379h82.643 V145.129z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M240.509,295.241L240.509,295.241c-2.043,0-3.604-0.239-4.563-0.444 c-42.932-6.207-90.242-35.064-140.625-85.785c-1.42-1.429-2.456-2.476-3.063-3.042c-0.138-0.122-0.265-0.25-0.398-0.39 c-0.357-0.371-1.031-1.035-1.981-1.96C39.222,153.941,9.17,104.895,2.942,61.771C2.146,57.957,0.666,43.979,16.98,29.478 C27.527,19.543,46.914,2.687,57.972,1.446c0.648-0.097,1.552-0.193,2.654-0.193c3.441,0,12.18,1.042,19.076,10.704 l33.177,49.751c4.462,5.376,9.413,17.295,1.908,30.971l-13.696,24.789c7.27,8.898,23.547,28.326,36.688,40.542 c0.377,0.297,0.735,0.627,1.067,0.99l0.071,0.064c0.286,0.276,0.551,0.566,0.791,0.875 c12.222,13.153,31.67,29.442,40.565,36.719l24.765-13.69c4.678-2.562,9.495-3.854,14.34-3.854 c8.552,0,14.532,4.077,16.565,5.692l49.605,33.071c10.2,7.272,11.567,16.871,10.741,21.956 c-1.297,11.062-18.106,30.396-28.188,41.118C257.079,293.361,246.072,295.241,240.509,295.241z M104.895,192.742 c0.735,0.693,1.878,1.844,3.399,3.375c59.383,59.771,103.808,76.832,130.616,80.619c0.413,0.057,0.828,0.143,1.23,0.261 c-0.246-0.071,0.02-0.052,0.366-0.052c2.013,0,7.401-0.812,14.093-8.336c11.719-12.465,22.631-26.778,23.528-30.827 c0.034-0.853-0.133-0.429,0.058-0.908c-0.078-0.644-0.537-2.16-3.026-3.937l-49.74-33.162c-0.379-0.248-0.737-0.533-1.071-0.836 v0.004c-0.013,0-2.007-1.534-4.969-1.534c-1.74,0-3.594,0.536-5.518,1.586l-30.119,16.651 c-3.236,1.783-7.217,1.451-10.107-0.842c-1.248-0.984-30.736-24.406-47.786-42.906c-18.503-17.049-41.925-46.533-42.91-47.784 c-2.292-2.894-2.619-6.876-0.837-10.103l16.662-30.153c3.497-6.371,0.082-10.419,0.046-10.455 c-0.306-0.337-0.587-0.694-0.837-1.078l-33.324-49.98c-1.618-2.256-3.125-2.706-3.793-2.782 c-0.484,0.173-0.454,0.092-0.984,0.092c-0.087,0-0.184,0-0.302,0.011c-3.65,0.853-17.974,11.766-30.246,23.308 c-9.53,8.479-8.525,14.768-8.474,15.033c0.112,0.399,0.101,0.414,0.158,0.833c5.457,38.633,34.461,85.412,81.681,131.719 C103.685,191.532,104.43,192.268,104.895,192.742z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M220.264,127.58c-0.369-14.522-6.178-28.111-16.429-38.367c-10.588-10.588-24.717-16.417-39.787-16.417 h-0.081V53.989h0.081c20.103,0,38.96,7.786,53.091,21.92c13.659,13.656,21.409,31.797,21.898,51.176L220.264,127.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M257.915,125.15c-0.604-23.88-10.159-46.233-26.974-63.049c-17.418-17.412-40.646-27.004-65.402-27.004 h-0.094V16.291l0.082-0.004c29.804,0,57.756,11.547,78.718,32.513c20.226,20.219,31.721,47.126,32.442,75.856L257.915,125.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#27346A",
    d: "M151.08,1c-39.52,0-71.551,32.038-71.551,71.551c0,39.526,32.031,71.557,71.551,71.557 c39.525,0,71.551-32.031,71.551-71.557C222.631,33.038,190.605,1,151.08,1z M151.08,120.036 c-26.181,0-47.479-21.305-47.479-47.485c0-26.181,21.298-47.479,47.479-47.479c26.182,0,47.479,21.298,47.479,47.479 C198.559,98.731,177.262,120.036,151.08,120.036z"
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M69.972,219.588c0-13.602,11.068-24.67,24.669-24.67h115.618c13.603,0,24.669,11.068,24.669,24.67v77.918 H259v-77.918c0-26.805-21.936-48.742-48.741-48.742H94.641c-26.805,0-48.708,21.938-48.708,48.742v77.918h24.039V219.588z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#27346A",
    d: "M294.109,141.576c-0.711-7.645-4.014-14.728-9.482-20.197l-92.792-92.644 c-6.208-6.209-14.493-9.626-23.323-9.626s-17.109,3.417-23.325,9.631l-2.138,2.139c-12.858,12.862-12.858,33.79,0,46.658 l32.741,32.741H37.887c-18.194,0-32.99,14.795-32.99,32.99v3.025c0,18.189,14.796,32.989,32.99,32.989l105.73,0.01 c4.72,0,8.552-3.828,8.552-8.553c0-4.722-3.832-8.554-8.552-8.554l-105.73-0.011c-8.759,0-15.884-7.131-15.884-15.884v-3.025 c0-8.764,7.125-15.884,15.884-15.884h148.359c2.798-0.21,4.911-0.859,6.597-1.651c0.253-0.115,0.507-0.23,0.734-0.354 c0.34-0.181,0.649-0.363,0.946-0.554c0.181-0.114,0.347-0.229,0.51-0.349c0.277-0.195,0.544-0.386,0.771-0.577 c0.053-0.048,0.088-0.086,0.139-0.125c0.481-0.429,0.869-0.82,1.166-1.183c0.074-0.085,0.156-0.172,0.224-0.257 c0.116-0.154,0.2-0.268,0.282-0.391c0.072-0.097,0.123-0.177,0.171-0.259c0.06-0.09,0.096-0.143,0.126-0.2 c0.057-0.095,0.084-0.152,0.084-0.152c2.488-4.134,1.824-8.109,0.54-11.054c-0.64-1.47-1.433-2.673-2.071-3.522l-41.316-41.312 c-6.194-6.195-6.194-16.275-0.006-22.471l2.141-2.138c2.978-2.983,6.968-4.62,11.229-4.62c4.26,0,8.252,1.637,11.229,4.62 l92.792,92.644c2.979,2.982,4.624,6.968,4.624,11.23c0,4.257-1.644,8.248-4.624,11.234l-92.377,92.377 c-5.971,5.955-16.49,5.967-22.471-0.016l-2.123-2.119c-6.195-6.193-6.195-16.277,0-22.471l49.351-49.359l1.125-1.125 c3.353-3.332,3.36-8.744,0.028-12.096c-3.34-3.346-8.752-3.359-12.099-0.023l-50.502,50.512 c-12.857,12.857-12.861,33.786,0.005,46.663l2.123,2.118c6.213,6.22,14.5,9.642,23.33,9.642s17.105-3.422,23.32-9.626 l92.386-92.236C291.896,160.916,295.05,151.074,294.109,141.576z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M83.595,56.219c-20.611,16.798-32.434,41.65-32.434,68.18c0,3.062,0.167,6.126,0.509,9.367 c0.44,4.186,3.975,7.291,8.09,7.291c0.284,0,0.572-0.014,0.864-0.046c4.475-0.472,7.717-4.481,7.245-8.954 c-0.282-2.667-0.418-5.172-0.418-7.658c0-21.612,9.636-41.86,26.434-55.554c3.489-2.836,4.01-7.972,1.168-11.453 C92.214,53.9,87.079,53.382,83.595,56.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M277.107,241.041l-39.438-48.286c13.505-19.417,21.45-42.968,21.45-68.356 c0-66.171-53.84-120.012-120.021-120.012c-66.178,0-120.016,53.841-120.016,120.012c0,66.181,53.838,120.02,120.016,120.02 c16.373,0,31.987-3.31,46.224-9.272l39.617,48.517c6.832,8.366,17.381,12.767,28.197,11.769 c6.449-0.593,12.497-3.074,17.516-7.162l1.859-1.521c6.703-5.474,10.865-13.253,11.74-21.896 C285.121,256.193,282.59,247.741,277.107,241.041z M35.372,124.398c0-57.19,46.532-103.723,103.727-103.723 c57.196,0,103.73,46.532,103.73,103.723c0,57.198-46.534,103.73-103.73,103.73C81.904,228.129,35.372,181.598,35.372,124.398z  M267.5,263.152c-0.424,4.182-2.441,7.928-5.648,10.55l-1.858,1.522c-2.4,1.959-5.306,3.145-8.402,3.43 c-5.229,0.488-10.321-1.631-13.603-5.647l-37.283-45.653c9.693-5.821,18.488-12.98,26.158-21.209l37.215,45.558 C266.695,254.912,267.913,258.98,267.5,263.152z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#27346A",
    d: "M188.736,147.341c0-14.821-17.086-26.356-40.933-28.637V92.737c12.765,1.532,21.382,6.159,23.875,10.099 l15.484-5.45c-4.766-11.171-19.949-19.22-39.359-21.088V62.686h-16.289v13.539c-24.441,2.018-42.078,13.676-42.078,28.734 s17.636,26.711,42.078,28.725V159.7c-14.469-1.511-23.7-7.082-25.45-11.055l-15.857,3.882 c3.547,12.488,19.768,21.771,41.307,23.547v13.939h16.289v-14.043C171.65,173.688,188.736,162.158,188.736,147.341z  M105.727,104.958c0-3.926,9.622-10.717,25.788-12.398v24.789C115.349,115.667,105.727,108.886,105.727,104.958z  M147.804,159.586v-24.498c15.463,1.882,24.645,8.417,24.645,12.253C172.448,151.173,163.268,157.708,147.804,159.586z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2B8BC6",
    d: "M69.114,11.065h160.758c36.333,0,65.886,29.553,65.886,65.885v81.657 c0,36.326-29.553,65.886-65.886,65.886h-9.955l40.677,37.745c5.331,4.947,5.647,13.287,0.698,18.625 c-2.604,2.795-6.124,4.214-9.661,4.214c-3.214,0-6.428-1.169-8.963-3.521l-89.602-83.416h76.806 c21.794,0,39.532-17.736,39.532-39.531V76.95c0-21.803-17.738-39.531-39.532-39.531H69.114c-21.795,0-39.531,17.728-39.531,39.531 v81.657c0,21.795,17.735,39.531,39.531,39.531h43.443l28.339,26.354H69.114c-36.333,0-65.884-29.561-65.884-65.887V76.95 C3.229,40.618,32.781,11.065,69.114,11.065z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#2B8BC6",
    d: "M192.714,98c0,0-6.246,32.06-43.097,32.06c-36.849,0-43.184-32.06-43.184-32.06H78.989 c0,0,9.826,57.24,70.751,57.24c60.925,0,70.505-57.24,70.505-57.24H192.714z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M118.22,121.017v-3.585c0-13.603,7.258-21.321,21.132-21.321c12.41,0,19.945,6.158,19.945,18.93 c0,8.639-2.754,13.602-8.64,19.759l-5.973,5.791c-2.477,2.391-8.267,8.177-9.096,12.039h23.803v12.406h-41.267v-2.296 c0-11.396,7.077-21.23,14.426-29.317l6.99-7.353c3.306-3.676,4.411-6.615,4.411-11.672c0-3.491-1.563-7.167-5.791-6.8 c-4.868,0.276-5.334,6.619-5.334,10.11v3.309H118.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M164.643,139.028l21.5-41.447h16.084v42.824h6.068v11.49h-6.068v13.143h-14.608v-13.143h-22.976V139.028 L164.643,139.028z M187.616,140.405v-22.332h-0.189l-11.211,22.332H187.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M165.074,52.147c-4.273,0-7.732-3.46-7.732-7.733V14.847c0-4.272,3.459-7.733,7.732-7.733 c4.271,0,7.732,3.461,7.732,7.733v29.567C172.807,48.687,169.346,52.147,165.074,52.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M282.266,139.771h-29.567c-4.271,0-7.732-3.461-7.732-7.733s3.461-7.734,7.732-7.734h29.567 c4.271,0,7.732,3.462,7.732,7.734S286.536,139.771,282.266,139.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M247.941,222.631c-1.979,0-3.957-0.756-5.467-2.266l-20.912-20.903c-3.021-3.024-3.021-7.918,0-10.938 c3.021-3.021,7.914-3.021,10.936-0.004l20.911,20.91c3.021,3.021,3.021,7.914,0,10.938 C251.898,221.875,249.923,222.631,247.941,222.631z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M103.117,77.814c-1.977,0-3.957-0.756-5.468-2.266l-20.906-20.92c-3.02-3.025-3.02-7.918,0.004-10.935 c3.02-3.02,7.918-3.02,10.934,0.005l20.908,20.915c3.02,3.021,3.02,7.918-0.004,10.939 C107.078,77.058,105.097,77.814,103.117,77.814z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M227.032,77.814c-1.981,0-3.958-0.756-5.47-2.261c-3.021-3.021-3.021-7.919,0-10.94l20.912-20.92 c3.021-3.02,7.914-3.02,10.935,0c3.021,3.021,3.021,7.914,0,10.935l-20.911,20.919 C230.986,77.058,229.012,77.814,227.032,77.814z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M199.134,59.048c-1.001,0-2.021-0.199-3.004-0.613c-3.931-1.657-5.776-6.196-4.116-10.132l11.495-27.247 c1.661-3.931,6.185-5.778,10.132-4.116c3.933,1.657,5.777,6.196,4.117,10.131l-11.496,27.247 C205.016,57.269,202.148,59.048,199.134,59.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M246.254,106.759c-3.054,0-5.945-1.82-7.166-4.824c-1.609-3.953,0.293-8.466,4.25-10.071L270.73,80.73 c3.965-1.618,8.467,0.298,10.076,4.251c1.606,3.957-0.293,8.466-4.25,10.076L249.16,106.19 C248.21,106.578,247.223,106.759,246.254,106.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M209.223,248.326c-3.056,0-5.947-1.816-7.168-4.819l-11.142-27.396 c-1.608-3.954,0.294-8.467,4.25-10.076c3.961-1.619,8.467,0.293,10.075,4.25l11.144,27.396 c1.609,3.957-0.294,8.467-4.251,10.075C211.177,248.146,210.189,248.326,209.223,248.326z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M132.076,58.598c-3.056,0-5.946-1.816-7.167-4.825L113.78,26.377c-1.605-3.957,0.298-8.467,4.255-10.076 c3.958-1.601,8.466,0.298,10.076,4.255l11.129,27.396c1.604,3.958-0.298,8.471-4.255,10.076 C134.03,58.417,133.042,58.598,132.076,58.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M273.053,185.32c-1.003,0-2.021-0.192-3.004-0.607l-27.246-11.504 c-3.936-1.661-5.777-6.197-4.117-10.132c1.668-3.933,6.188-5.774,10.135-4.117l27.244,11.504 c3.936,1.662,5.777,6.197,4.117,10.134C278.934,183.548,276.068,185.32,273.053,185.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M144.098,289.104L144.098,289.104c-3.436,0-5.921-0.797-7.155-1.307 c-28.89-9.852-57.818-35.837-85.984-77.246c-0.767-1.131-1.324-1.959-1.66-2.41c-0.091-0.121-0.173-0.246-0.259-0.373 c-0.19-0.293-0.557-0.813-1.07-1.539C19.459,165.489,5.06,127.77,6.32,97.129c-0.036-3.069,0.932-13.313,14.403-21.43 c6.516-4.185,23.009-14.197,31.38-14.197c0.561,0,1.096,0.039,1.592,0.1c4.777,0.432,10.74,3.4,14.15,10.71l16.345,38.275 c2.528,4.604,4.492,13.998-2.831,22.917l-11.953,14.512c4.014,7.304,12.272,21.878,19.384,31.492 c0.122,0.139,0.233,0.281,0.336,0.432c0.078,0.104,0.165,0.227,0.241,0.351c0.074,0.096,0.143,0.194,0.216,0.299 c0.117,0.183,0.224,0.363,0.328,0.548c6.395,10.11,17.023,23.111,22.396,29.504l17.834-5.916 c2.434-0.799,4.851-1.199,7.215-1.199c8.415,0,13.52,4.933,15.125,6.767l29.701,28.959c6.521,6.774,6.205,14.099,4.896,17.81 c-2.339,7.396-14.827,17.738-25.067,25.219C154.773,287.896,148.259,289.104,144.098,289.104z M143.079,273.58 c0.105,0,0.484,0.059,1.02,0.059l0,0c1.424,0,4.444-0.479,8.609-3.715c9.136-6.688,18.11-14.705,19.604-17.477 c0.028-0.1,0.06-0.193,0.09-0.288c-0.008-0.212-0.125-0.911-1.19-2.017l-29.788-29.037c-0.271-0.269-0.526-0.553-0.76-0.856l0,0 c-0.025-0.006-2.364-1.925-5.678-0.842l-22.754,7.552c-2.964,0.992-6.222,0.086-8.268-2.266 c-0.729-0.838-17.865-20.58-27.253-35.502c-0.027-0.034-0.048-0.069-0.07-0.104c-0.016-0.024-0.034-0.047-0.052-0.065 c-10.528-14.143-22.783-37.312-23.301-38.299c-1.45-2.758-1.11-6.115,0.872-8.522l15.258-18.521 c2.615-3.175,1.276-5.549,1.26-5.575c-0.199-0.328-0.379-0.672-0.526-1.026L53.726,78.612c-0.569-1.204-1.166-1.532-1.355-1.614 c-0.111,0-0.228-0.012-0.345-0.022c-2.96,0.329-13.739,5.83-23.138,11.854c-6.024,3.633-6.943,6.999-7.082,7.875 c0.074,0.375,0.004,0.259-0.022,0.833c-1.191,26.875,12.61,62.323,38.854,99.817c0.548,0.781,0.958,1.373,1.221,1.761 c0.419,0.579,1.049,1.502,1.886,2.735c32.795,48.215,60.758,65.437,78.445,71.396c0.588,0.192,0.462,0.065,0.872,0.333 C143.062,273.58,143.071,273.58,143.079,273.58z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M177.414,251.404h-64.441c-3.941,0-7.133,3.193-7.133,7.133c0,3.938,3.192,7.133,7.133,7.133h64.441 c3.938,0,7.134-3.195,7.134-7.133C184.548,254.598,181.352,251.404,177.414,251.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M161.107,279.525h-31.825c-3.94,0-7.132,3.195-7.132,7.132s3.192,7.133,7.132,7.133h31.825 c3.934,0,7.133-3.196,7.133-7.133C168.24,282.723,165.041,279.525,161.107,279.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M145.159,50.3c-47.351,0-85.748,37.682-85.748,84.182c0,22.038,6.774,37.614,15.949,48.882 c15.765,17.044,31.77,24.53,34.484,53.737h35.315h35.312c2.734-29.207,18.719-36.693,34.567-53.738 c10.659-12.582,15.937-26.846,15.937-48.881C230.975,87.982,192.527,50.3,145.159,50.3z M204.355,173.896 c-3.097,3.314-6.336,6.355-9.465,9.301c-10.627,9.996-21.558,20.275-26.447,39.641h-15.683v-57.623l22.236-22.319 c2.78-2.79,2.772-7.307-0.019-10.087c-2.793-2.782-7.308-2.772-10.086,0.018L145.194,152.6l-19.702-19.771 c-2.786-2.794-7.3-2.8-10.09-0.018c-2.79,2.78-2.798,7.298-0.02,10.087l23.113,23.195v56.747h-16.617 c-4.871-19.313-15.753-29.58-26.34-39.563c-3.105-2.933-6.317-5.957-9.394-9.256c-8.391-10.478-12.47-23.414-12.47-39.537 c0-38.552,32.068-69.917,71.483-69.917c39.452,0,71.552,31.365,71.552,69.917C216.711,151.986,213.129,163.438,204.355,173.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M144.83,35.556c3.94,0,7.132-3.194,7.132-7.132V10.132c0-3.938-3.192-7.132-7.132-7.132 s-7.133,3.194-7.133,7.132v18.291C137.697,32.361,140.889,35.556,144.83,35.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M250.766,48.175c-2.789-2.78-7.312-2.768-10.09,0.021l-14.803,14.862 c-2.777,2.792-2.771,7.307,0.023,10.088c1.394,1.385,3.211,2.077,5.031,2.077c1.829,0,3.659-0.7,5.055-2.099l14.808-14.862 C253.566,55.471,253.559,50.955,250.766,48.175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M64.494,73.145c2.79-2.779,2.798-7.296,0.016-10.086L49.711,48.196c-2.778-2.79-7.299-2.801-10.085-0.02 c-2.794,2.778-2.802,7.296-0.024,10.086l14.806,14.862c1.393,1.399,3.22,2.099,5.051,2.099 C61.278,75.224,63.101,74.531,64.494,73.145z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 69.211,
    fill: "#25356C",
    width: 17.329,
    height: 17.329
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 69.211,
    fill: "#25356C",
    width: 17.328,
    height: 17.329
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 103.869,
    fill: "#25356C",
    width: 17.329,
    height: 17.329
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 103.869,
    fill: "#25356C",
    width: 17.328,
    height: 17.329
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.655,
    y: 172.537,
    fill: "#25356C",
    width: 17.33,
    height: 17.329
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.655,
    y: 276.511,
    fill: "#25356C",
    width: 17.33,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.655,
    y: 241.854,
    fill: "#25356C",
    width: 17.33,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.655,
    y: 207.193,
    fill: "#25356C",
    width: 17.33,
    height: 17.33
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.029,
    y: 276.511,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.029,
    y: 241.854,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.029,
    y: 207.193,
    fill: "#25356C",
    width: 17.328,
    height: 17.33
  }))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 277.163,
    fill: "#25356C",
    width: 17.329,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 277.163,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 242.506,
    fill: "#25356C",
    width: 17.329,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 242.506,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 207.848,
    fill: "#25356C",
    width: 17.329,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 207.848,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 173.188,
    fill: "#25356C",
    width: 17.329,
    height: 17.33
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 173.188,
    fill: "#25356C",
    width: 17.328,
    height: 17.33
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.573,
    y: 138.531,
    fill: "#25356C",
    width: 17.329,
    height: 17.328
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.064,
    y: 138.531,
    fill: "#25356C",
    width: 17.328,
    height: 17.328
  })))), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M21,161.025v133.646h15.163V161.025c0-3.524,2.976-6.5,6.498-6.5H71.9v-15.161H42.661 C30.748,139.364,21,149.112,21,161.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M260.339,174.289h-29.356v15.163h29.356c3.522,0,6.499,2.979,6.499,6.498v98.724H282V195.95 C282,184.036,272.254,174.289,260.339,174.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M192.047,36.825h-33.162V10.476c0-4.185-3.396-7.582-7.58-7.582c-4.188,0-7.582,3.397-7.582,7.582v26.349 h-32.808c-11.914,0-21.661,9.747-21.661,21.662v236.188h0.063h15.1h0.063l-0.063-236.188c0-3.521,2.976-6.499,6.498-6.499h81.132 c3.523,0,6.499,2.978,6.499,6.499l-0.026,236.188h0.026h15.138h0.024V58.486C213.708,46.572,203.962,36.825,192.047,36.825z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M245.854,3H107.799l-2.052,0.34l-0.018,0.128c-1.291,0.384-2.527,1.024-3.623,1.946L36.679,60.436 c-1.96,1.651-3.096,3.888-3.446,6.238l-0.13-0.02v203.858c0,13.875,11.351,25.228,25.225,25.228h187.525 c13.873,0,25.226-11.353,25.226-25.228V28.225C271.078,14.351,259.727,3,245.854,3z M253.422,270.512 c0,4.104-3.464,7.567-7.568,7.567H58.328c-4.099,0-7.568-3.464-7.568-7.567V74.965l51.869-43.626v41.625H80.562v17.657h39.695 l0.029-69.964h125.567c4.104,0,7.566,3.469,7.566,7.568L253.422,270.512L253.422,270.512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M152.882,145.461c0-4.104,3.464-7.567,7.567-7.567h41.228c4.099,0,7.566,3.463,7.566,7.567v24.708H226.9 v-24.708c0-13.874-11.353-25.225-25.226-25.225h-41.228c-13.874,0-25.225,11.351-25.225,25.225v24.708h17.658L152.882,145.461 L152.882,145.461z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M224.02,212.997H79.606c-4.875,0-8.829-3.951-8.829-8.828c0-4.873,3.954-8.829,8.829-8.829H224.02 c4.875,0,8.828,3.956,8.828,8.829C232.848,209.046,228.895,212.997,224.02,212.997z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M224.02,250.539H79.606c-4.875,0-8.829-3.951-8.829-8.828c0-4.873,3.954-8.83,8.829-8.83H224.02 c4.875,0,8.828,3.957,8.828,8.83C232.848,246.588,228.895,250.539,224.02,250.539z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M181.07,42.286c-17.616,0-31.903,14.283-31.903,31.906s14.287,31.901,31.903,31.901 c17.625,0,31.877-14.278,31.877-31.901S198.695,42.286,181.07,42.286z M181.07,88.435c-7.854,0-14.246-6.385-14.246-14.243 s6.395-14.249,14.246-14.249c7.846,0,14.221,6.391,14.221,14.249S188.916,88.435,181.07,88.435z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M74.834,223.327h186.428L261.33,4h-17.307v0.097H84.869c-26.902,0-48.787,21.996-48.787,49.039v190.987 h0.043c-0.009,0.279-0.043,0.555-0.043,0.839v10.093c0,21.479,17.385,38.946,38.752,38.946h186.428v-17.308H74.834 c-11.869,0-21.532-9.707-21.532-21.639V244.96C53.302,233.034,62.965,223.327,74.834,223.327z M90.587,21.404h153.437v184.618 H90.587V21.404z M53.302,53.135c0-13.406,8.325-24.865,20.036-29.505v182.468c-7.388,0.285-14.26,2.617-20.036,6.51V53.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25356C",
    d: "M78.239,241.195c-4.757,0-8.61,3.873-8.61,8.652s3.853,8.652,8.61,8.652h183.275v-17.309H78.239V241.195z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23366D",
    d: "M229.229,214.268c0,5.004,4.059,9.064,9.067,9.064c5.005,0,9.065-4.061,9.065-9.064 c0-5.007-4.062-9.065-9.065-9.065C233.285,205.2,229.229,209.261,229.229,214.268z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#23366D",
    d: "M150.489,256.66H71.311c-3.894,0-7.051-3.158-7.051-7.051c0-3.896,3.158-7.053,7.051-7.053h79.179 c3.894,0,7.05,3.155,7.05,7.053C157.539,253.502,154.383,256.66,150.489,256.66z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#23366D",
    d: "M268.656,20.946h-60.719c-15.512,0-28.207,12.689-28.207,28.206v11.175h14.104V49.151 c0-7.775,6.327-14.104,14.104-14.104h60.719c7.773,0,14.103,6.328,14.103,14.104v179.353c0,7.773-6.325,14.102-14.103,14.102 l-85.161-0.121c4.88,8.473,14.019,14.226,24.442,14.226h60.719c15.511,0,28.203-12.694,28.203-28.204V49.151 C296.861,33.635,284.167,20.946,268.656,20.946z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#23366D",
    d: "M256.598,65.521h-36.6c-3.896,0-7.053-3.156-7.053-7.051c0-3.892,3.156-7.051,7.053-7.051h36.6 c3.896,0,7.051,3.16,7.051,7.051C263.646,62.365,260.491,65.521,256.598,65.521z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#23366D",
    d: "M189.68,76.436H32.112c-15.511,0-28.206,12.693-28.206,28.206v93.461 c0,15.515,12.694,28.203,28.206,28.203H189.68c15.512,0,28.206-12.688,28.206-28.203v-93.461 C217.887,89.129,205.191,76.436,189.68,76.436z M203.783,198.104c0,7.774-6.328,14.104-14.104,14.104H32.112 c-7.775,0-14.103-6.327-14.103-14.104v-93.46c0-7.775,6.328-14.103,14.103-14.103H189.68c7.775,0,14.104,6.328,14.104,14.103 L203.783,198.104L203.783,198.104z"
  })), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#23366D",
    d: "M117.229,176.516H98.062V142.07c0-4.243,1.626-8.274,4.597-11.175 c3.042-3.041,7.144-4.668,11.529-4.668c9.336,0,16.125,5.94,16.125,14.498c0,4.175-1.768,7.428-4.314,9.549 c4.172,2.192,6.578,6.225,6.578,11.812C132.578,170.855,126.708,176.516,117.229,176.516z M107.399,146.597h7.78 c0.566,0,5.729-0.142,5.729-5.446c0-4.102-3.183-5.799-6.719-5.799c-3.96,0-6.79,2.971-6.79,6.719V146.597z M115.674,155.297 h-8.275v12.52h8.417c3.677,0,7.143-1.344,7.143-6.152C122.958,157.561,120.342,155.297,115.674,155.297z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#64CCC1",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    cx: 150,
    cy: 150,
    r: 145.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#64CCC1",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 61.5,
    y1: 140.5,
    x2: 135,
    y2: 214
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#64CCC1",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 128.5,
    y1: 214,
    x2: 244.75,
    y2: 97.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#FFFFFF",
    cx: 150,
    cy: 150,
    r: 145.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#7363AA",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 150,
    y1: 58.5,
    x2: 150,
    y2: 169
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#7363AA",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 148,
    y1: 164.5,
    x2: 208.25,
    y2: 224.75
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_1_",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#FFFFFF",
    cx: 150,
    cy: 149,
    r: 145.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#DB0000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 88.5,
    y1: 88.5,
    x2: 216.5,
    y2: 216.5
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#DB0000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    x1: 218.5,
    y1: 85.5,
    x2: 90.5,
    y2: 213.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableImage);
export default __webpack_public_path__ + "static/media/enableImage.af41b1378505c25382010197ee959810.svg";
export { ForwardRef as ReactComponent };